import { render, staticRenderFns } from "./FollowerGoalSettingsPopoutApp.vue?vue&type=template&id=0b6e8af3"
import script from "./FollowerGoalSettingsPopoutApp.vue?vue&type=script&lang=js"
export * from "./FollowerGoalSettingsPopoutApp.vue?vue&type=script&lang=js"
import style0 from "./FollowerGoalSettingsPopoutApp.vue?vue&type=style&index=0&id=0b6e8af3&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports